import request from "@/utils/request";
/**
 * 照片同步记录
 * @param {*} data 查询条件
 * @param {Number} data.schoolId 学校id
 * @param {String} data.mobileNumber 手机号码
 * @param {String} data.studentCode 学号
 * @param {String} data.stime 开始时间
 * @param {String} data.etime 结束时间
 * @param {Number} page 页码
 * @param {Number} size 每页数量
 * @returns
 */
export async function queryOrders(data, page = 1, size = 10) {
  return await request({
    url: `/sys/studentYunInfo/queryOrders?currentPage=${page}&pageSize=${size}`,

    method: "post",
    data,
  });
}
/**
 * 查看日志列表
 * @param {Number} id 记录id
 * @returns
 */
export async function getLogsList(id) {
  return await request({
    url: `/sys/yunRecord/getLogs/${id}`,

    method: "get",
  });
}

/**
 * 云盘任务列表
 * @param {*} data 查询条件
 * @param {Number} data.schoolId 学校id
 * @param {String} data.mobileNumber 手机号码
 * @param {String} data.studentCode 学号
 * @param {String} data.stime 开始时间
 * @param {String} data.etime 结束时间
 * @param {Number} page 页码
 * @param {Number} size 每页数量
 * @returns
 */
export async function queryTasks(data, page = 1, size = 10) {
  return await request({
    url: `/sys/studentYunInfo/queryTasks?currentPage=${page}&pageSize=${size}`,

    method: "post",
    data,
  });
}

/**
 * 处理消息通知
 * @returns
 */
export async function getNotice(data) {
  console.debug(data);

  return await request({
    url: `/api/photo/yum/notice?uuid=${data.uuid}&studentId=${data.studentId}&orderId=${data.orderId}`,

    method: "get",
  });
}

/**
 * 查询云盘任务汇总
 * @param {Number} id 记录id
 * @returns
 */
export async function queryTasksSummary(data) {
  if (data.startTime && data.startTime.indexOf("00:00:00") == -1)
    data.startTime += " 00:00:00";
  if (data.endTime && data.endTime.indexOf("23:59:59") == -1)
    data.endTime += " 23:59:59";
  return await request({
    url: `/sys/studentYunInfo/queryTasksSummary`,

    method: "post",
    data,
  });
}

export function queryCloudDiskSmsUsers(params) {
  return request({ url: "/sys/cloudDiskSms/users", method: "get", params });
}

export function queryCloudDiskSmsFailureUsers(params) {
  return request({
    url: "/sys/cloudDiskSms/failureUsers",
    method: "get",
    params,
  });
}

export function sendCloudDiskSms(data) {
  return request({ url: "/sys/cloudDiskSms/send", method: "post", data });
}

export function previewCloudDiskSmsBatch(data) {
  return request({
    url: "/sys/cloudDiskSms/batchPreview",
    method: "post",
    data,
  });
}

export function sendCloudDiskSmsBatch(data) {
  return request({ url: "/sys/cloudDiskSms/batchSend", method: "post", data });
}

/**
 * 分页查询云盘短信下发明细，用于投诉凭证查询和失败补发。
 */
export function queryCloudDiskSmsRecords(params) {
  return request({ url: "/sys/cloudDiskSms/records", method: "get", params });
}

/**
 * 按历史记录补发短信；后端会保留原记录并新增一条补发记录。
 */
export function resendCloudDiskSms(recordId) {
  return request({
    url: `/sys/cloudDiskSms/${recordId}/resend`,
    method: "post",
  });
}
